import { Link } from "react-router-dom";
import { TaskStatusSelect } from "../../components/TaskStatusSelect";
import type { OperationsSnapshot, TaskStatus, WorkTask } from "../../domain/operations";
import { workClassLabels } from "../../domain/operations";

export function TaskRow({ task, snapshot, onStatus }: {
  task: WorkTask;
  snapshot: OperationsSnapshot;
  onStatus: (id: string, status: TaskStatus, blockerNote?: string) => void;
}) {
  const event = snapshot.events.find((item) => item.id === task.eventId);
  const staff = snapshot.staff.find((item) => item.id === task.assignedTo);
  if (!event) return null;

  return (
    <div className={`task-row ${task.status === "blocked" ? "blocked-row" : ""}`} role="row">
      <button className={`check ${task.status === "complete" ? "done" : ""}`} onClick={() => onStatus(task.id, task.status === "complete" ? "scheduled" : "complete")} aria-label={`${task.status === "complete" ? "Reopen" : "Complete"} ${task.title}`}>{task.status === "complete" ? "✓" : ""}</button>
      <div className="task-name">
        <strong>{task.title}</strong>
        <small className={task.status === "blocked" ? "blocked-note" : ""}>{task.blockerNote ? `! ${task.blockerNote}` : task.activityLabel ? `${task.activityLabel} · ${task.detail}` : task.detail}</small>
      </div>
      <div className="event-cell">
        <i className={`event-dot ${event.color}`} />
        <Link to={`/events/${event.id}`}>{event.name}<small>{event.dateLabel}</small></Link>
      </div>
      <span className={`tag ${task.classification}`}>{workClassLabels[task.classification]}</span>
      <div className="assignee"><span className="mini-avatar">{staff?.initials}</span>{staff?.name}</div>
      <TaskStatusSelect task={task} onStatus={onStatus} />
      <Link className="row-menu" aria-label={`Open ${event.name} work`} to={`/events/${event.id}/work`}>•••</Link>
    </div>
  );
}
